import { render, staticRenderFns } from "./CurrencyPicker.vue?vue&type=template&id=a712b344&scoped=true"
import script from "./CurrencyPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./CurrencyPicker.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CurrencyPicker.vue?vue&type=style&index=0&id=a712b344&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a712b344",
  null
  
)

export default component.exports